import { FC, useEffect, useState } from "react";
import classes from './addPenaltyBonus.module.scss'
import { Modal } from "../../../shared/ui/modal";
import { MyButton } from "../../../shared/ui/button";
import { MyInput } from "../../../shared/ui/input";
import { useGlobalLoadingActions } from "../../../entities/globalLoading";
import { useGlobalMessageActions } from "../../../entities/globalMessage";
import { MyError } from "../../../shared/lib/error/MyError";
import { AuthError } from "../../../shared/lib/error/AuthError";
import { useMyActions } from "../../../entities/my";
import { SwitchButton } from "../../../shared/ui/switchButton";
import { MyTextarea } from "../../../shared/ui/myTextarea";
import { TPenaltyBonus } from "../../../entities/penaltyBonus";

interface IProps {
    request: (amount: string, comment: string, type: TPenaltyBonus, actualDate: string) => Promise<void>;
    bonusLabel?: string;
    penaltyLabel?: string;
}

export const AddPenaltyBonus: FC<IProps> = ({request, bonusLabel = 'Премия', penaltyLabel = 'Штраф'}) => {

    const getToday = () => {
        const today = new Date()
        const month = String(today.getMonth() + 1).padStart(2, '0')
        const day = String(today.getDate()).padStart(2, '0')
        return `${today.getFullYear()}-${month}-${day}`
    }

    const [amount, setAmount] = useState<string>('')
    const [comment, setComment] = useState<string>('')
    const [type, setType] = useState<TPenaltyBonus>('bonus')
    const [actualDate, setActualDate] = useState<string>(getToday())
    const [error, setError] = useState<string>('')
    const [open, setOpen] = useState<boolean>(false)
    const {setIsLoading} = useGlobalLoadingActions()
    const {setGlobalMessage} = useGlobalMessageActions()
    const {setIsAuth} = useMyActions()

    const check = (): boolean => {
        if(!amount){
            setError(`Введите сумму: ${bonusLabel.toLowerCase()} / ${penaltyLabel.toLowerCase()}`)
            return false
        }
        if(!actualDate){
            setError('Выберите дату начисления')
            return false
        }
        return true
    }

    const add = async () => {
        try{
            if(!check()){
                return
            }
            setIsLoading(true)
            await request(amount, comment, type, actualDate)
            setGlobalMessage({message: 'Начисление добавлено', type: 'ok'})
            setOpen(false)
        }
        catch(e){
            console.log(e)
            setOpen(false)
            if(e instanceof AuthError){
                setIsAuth(false)
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else if(e instanceof MyError){
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else{
                setGlobalMessage({message: 'Ошибка при добавлении начисления', type: 'error'})
            }
        }
        finally{
            setIsLoading(false)
        }
    }

    const onSelected = (button: 1 | 2) => {
        if(button === 1){
            setType('bonus')
        }
        else{
            setType('penalty')
        }
    }

    useEffect(() => {
        if(!open){
            setAmount('')
            setComment('')
            setActualDate(getToday())
            setError('')
        }
    }, [open])

    return (
        <section className={classes.container}>
            <section className={classes.button}>
                <MyButton 
                    onClick={() => setOpen(true)}
                >
                    Добавить начисление
                </MyButton>
            </section>
            <Modal
                open={open}
                setOpen={setOpen}
            >
                <section className={classes.content}>
                    <SwitchButton
                        text1={bonusLabel}
                        text2={penaltyLabel}
                        selected={type === 'bonus' ? 1 : 2}
                        onSelected={onSelected}
                    />
                    <MyInput
                        title="Дата начисления"
                        type="date"
                        value={actualDate}
                        setValue={setActualDate}
                        setError={setError}
                    />
                    <MyInput
                        title="Сумма"
                        type="number"
                        value={amount}
                        setValue={setAmount}
                        setError={setError}
                    />
                    <section>
                        <section className={classes.sign}>
                            Комментарий
                        </section>
                        <MyTextarea 
                            value={comment}
                            setValue={setComment}
                        />
                    </section>
                    <section className={classes.button}>
                        <MyButton
                            onClick={add}
                            error={error}
                        >
                            Добавить
                        </MyButton>
                    </section>
                </section>
            </Modal>
        </section>
    )
}
